import { API, I18nt } from 'utils';
import cn from 'classnames';
import styles from './placeView.module.less';
import { useAgendarCita } from 'pages/AgendarCita/AgendarCitaContext';
import { Clinic } from 'utils/interfaces';
import { Col, Row, Spin } from 'antd';
import { useEffect, useState } from 'react';

const PlaceView = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { clinics, dispatch, selectedClinic } = useAgendarCita();

  const onClinicClick = (place: Clinic) => {
    dispatch({ type: 'setClinic', payload: { selectedClinic: place } });
  };

  useEffect(() => {
    setIsLoading(true);
    const getEstablecimientos = async () => {
      const { data } = await API.getEstablecimientos();
      dispatch({ type: 'setClinicsList', payload: { clinics: data } });
      setIsLoading(false);
    };
    getEstablecimientos();

  }, [dispatch]);

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className={styles.spinCont}>
          <Spin />
        </div>
      );
    }

    return clinics.map((place) => (
      <div
        key={place.idEstablecimiento}
        className={cn(styles.place, {
          [styles.selected]:
            selectedClinic?.idEstablecimiento ===
            place.idEstablecimiento,
        })}
        onClick={() => onClinicClick(place)}
      >
        {place.establecimiento.toLocaleLowerCase()}
      </div>
    ));
  };

  return (
    <Row justify='center'>
      <Col xs={24} lg={12}>
        <section className={styles.placeSection}>
          <div className={styles.title}>{I18nt('seleccionar_lugar')}</div>
          <div className={styles.placesContainer}>
            {renderContent()}{ }
          </div>
        </section>
      </Col>
    </Row>
  );
};

export default PlaceView;
